module.exports = __webpack_public_path__ + "static/media/img5.54f96a9f.jpg";